import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { get, map, filter, isEmpty } from "lodash";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";

import WalkInOutVerification from "./WalkInOutVerification";
import FormSection from "../../Common/FormSection";
import ProfileSearchInput from "../../Common/ProfileSearchInput";
import DatePicker from "../../Common/DatePicker";
import { walkInOut } from "../../../constants/reducers";
import colors from "../../../assets/style/colors";
import WalkInOutTemperature from "./WalkInOutTemperature";

const styles = {
  formContainer: {
    padding: "24px 24px 0px 24px",
  },
  formLabel: {
    fontSize: "1em",
    color: `${colors.black87} !important`,
    fontWeight: 500,
  },
  formControlLabel: {
    fontSize: "1em",
    color: colors.black54,
  },
  formControlRoot: {
    height: "30px",
  },
};

const WalkInOutForm = (props) => {
  const {
    classes,
    activeSite,
    formValues,
    handleChange,
    language,
    onSubmitVerification,
    verification,
    onSubmitTemperature,
    temperature,
    lov,
    eventGroupTypeId,
  } = props;

  return (
    <>
      <Grid container wrap="nowrap" className={classes.formContainer}>
        <Grid item xs={6} style={{ paddingRight: "20px" }}>
          <Grid container direction="column">
            <FormSection
              formValue={[get(formValues, ["zone"]) || ""]}
              setFormValue={(id, index, value) =>
                handleChange(id, get(activeSite, ["id"]), value)
              }
              title={"zone"}
              id={"zone"}
              type="select"
              options={{
                comboBox: true,
                options: map(
                  filter(
                    get(activeSite, ["zones"]),
                    (z) =>
                      z.active &&
                      z.is_human_access &&
                      (eventGroupTypeId === 4
                        ? z.is_entrance
                        : eventGroupTypeId === 5
                        ? z.is_exit
                        : true)
                  ),
                  (z) => ({
                    id: z.id,
                    name: z.name,
                  })
                ),
              }}
            />
            <ProfileSearchInput
              profileType={1}
              title={"humanProfile"}
              selectProfile={(profile) =>
                handleChange("profile", null, profile)
              }
              selectedProfile={get(formValues, ["profile"])}
              minHeight={get(formValues, ["profile"]) ? null : 220}
            />
            {get(formValues, ["profile"]) && (
              <Grid
                container
                wrap="nowrap"
                style={{ marginTop: "-2px", backgroundColor: colors.lightGrey }}
              >
                <Grid item xs={8}>
                  <WalkInOutVerification
                    profile={get(formValues, ["profile"])}
                    language={language}
                    onSubmitVerification={onSubmitVerification}
                    verification={verification}
                    noVerificationSubmit
                    companies={[get(activeSite, ["company_id"])]}
                    sites={[get(activeSite, ["id"])]}
                    zones={[get(formValues, ["zone"])]}
                  />
                </Grid>
                <Grid item xs={4}>
                  <WalkInOutTemperature
                    profile={get(formValues, ["profile"])}
                    language={language}
                    onSubmitTemperature={onSubmitTemperature}
                    temperature={temperature}
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid item xs={6} style={{ paddingLeft: "20px" }}>
          <FormControl component="fieldset">
            <FormLabel component="legend" classes={{ root: classes.formLabel }}>
              {I18n.get("site_dateTime")}
            </FormLabel>
            <RadioGroup
              name="date"
              value={get(formValues, ["dateType"])}
              onChange={(e) => handleChange("dateType", null, e.target.value)}
            >
              <FormControlLabel
                value="current"
                control={<Radio color="primary" />}
                label={I18n.get("site_currentDateTime")}
                classes={{
                  label: classes.formControlLabel,
                  root: classes.formControlRoot,
                }}
              />
              <FormControlLabel
                value="custom"
                control={<Radio color="primary" />}
                label={I18n.get("site_pastDateTime")}
                classes={{
                  label: classes.formControlLabel,
                  root: classes.formControlRoot,
                }}
              />
            </RadioGroup>
          </FormControl>
          {get(formValues, ["dateType"]) === "custom" && (
            <DatePicker
              name="date"
              value={get(formValues, ["date"])}
              onChange={(id, value) => handleChange("date", null, value)}
              width="100%"
            />
          )}
          <Box style={{ marginTop: "20px" }}>
            <FormSection
              formValue={[get(formValues, ["note"]) || ""]}
              setFormValue={handleChange}
              title={"comments"}
              id={"note"}
              type="input"
              options={{
                multiline: true,
                rows: 5,
              }}
            />
          </Box>
        </Grid>
      </Grid>
      {!isEmpty(verification) && (
        <Grid item style={{ margin: "24px auto 30px", maxWidth: "300px" }}>
          <FormSection
            formValue={[get(formValues, ["lukeAction"]) || ""]}
            setFormValue={handleChange}
            attribute={{ id: 158 }}
            id={"lukeAction"}
            type="select"
            options={{
              options: map(
                filter(get(lov, [158]), (item) => item.active),
                (item) => ({
                  id: item.id,
                  name: get(item, [`name_${language}`]),
                })
              ),
            }}
          />
        </Grid>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    activeSite: get(state, ["siteEntranceExit", walkInOut, "activeSite"]),
  };
};

export default connect(mapStateToProps)(withStyles(styles)(WalkInOutForm));
